// Generated by purs version 0.13.8
"use strict";
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Show = require("../Data.Show/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var TypeMissmatch = (function () {
    function TypeMissmatch(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    TypeMissmatch.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new TypeMissmatch(value0, value1, value2);
            };
        };
    };
    return TypeMissmatch;
})();
var DifferentLength = (function () {
    function DifferentLength(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    DifferentLength.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new DifferentLength(value0, value1, value2);
            };
        };
    };
    return DifferentLength;
})();
var RecursiveType = (function () {
    function RecursiveType(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    RecursiveType.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new RecursiveType(value0, value1, value2);
            };
        };
    };
    return RecursiveType;
})();
var UnboundVariable = (function () {
    function UnboundVariable(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    UnboundVariable.create = function (value0) {
        return function (value1) {
            return new UnboundVariable(value0, value1);
        };
    };
    return UnboundVariable;
})();
var Stacked = (function () {
    function Stacked(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Stacked.create = function (value0) {
        return function (value1) {
            return new Stacked(value0, value1);
        };
    };
    return Stacked;
})();
var printError = function ($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof TypeMissmatch) {
            $tco_done = true;
            return "Could not match type " + (Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v.value0) + (" with type " + Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v.value1)));
        };
        if (v instanceof DifferentLength) {
            $tco_done = true;
            return "Could not match types " + (Data_Show.show(Data_List_Types.showList(Lunarbox_Data_Dataflow_Type.typeShow))(v.value0) + (" with types " + (Data_Show.show(Data_List_Types.showList(Lunarbox_Data_Dataflow_Type.typeShow))(v.value1) + " because the lengths are different")));
        };
        if (v instanceof RecursiveType) {
            $tco_done = true;
            return "Type " + (Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v.value1) + " contains a reference to itself");
        };
        if (v instanceof UnboundVariable) {
            $tco_done = true;
            return "Variable " + (Data_Show.show(Lunarbox_Data_Dataflow_Expression.showVarName)(v.value0) + " is not in scope");
        };
        if (v instanceof Stacked) {
            $copy_v = v.value0;
            return;
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.TypeError (line 39, column 1 - line 39, column 46): " + [ v.constructor.name ]);
    };
    while (!$tco_done) {
        $tco_result = $tco_loop($copy_v);
    };
    return $tco_result;
};
var getLocation = function (v) {
    if (v instanceof TypeMissmatch) {
        return v.value2;
    };
    if (v instanceof DifferentLength) {
        return v.value2;
    };
    if (v instanceof RecursiveType) {
        return v.value2;
    };
    if (v instanceof UnboundVariable) {
        return v.value1;
    };
    if (v instanceof Stacked) {
        return v.value1;
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.TypeError (line 27, column 1 - line 27, column 42): " + [ v.constructor.name ]);
};
module.exports = {
    TypeMissmatch: TypeMissmatch,
    DifferentLength: DifferentLength,
    RecursiveType: RecursiveType,
    UnboundVariable: UnboundVariable,
    Stacked: Stacked,
    getLocation: getLocation,
    printError: printError
};
